import { FC, useEffect, useState, useMemo } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { GridColumns, GridCellParams, DataGrid, GridSortDirection } from '@material-ui/data-grid';
import { Grid, Paper, IconButton } from '@material-ui/core';
import { EmailTemplateForm } from 'components/Forms';
import { Search } from 'components/Search';
import EditIcon from '@material-ui/icons/Edit';
import { observer } from 'mobx-react-lite';
import { orange } from '@material-ui/core/colors';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
export const EmailTemplatesTable: FC = observer(() => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: Settings: Email Templates';
  }, []);

  const {
    emailTemplatesTableStore: { emailTempaltesView, getEmailTemplates, setFilter, setSelectedId },
    notificationStore: { openNotification },
  } = useStore();

  const [openEmailTemplateModal, setOpenEmailTemplateModal] = useState<boolean>(false);

  const getEmailTemplatesReq = useQuery('getEmailTemplatesReq', () => getEmailTemplates(), {
    onError: () => openNotification('error', `Can't get email templates`),
  });

  useAppPreloader(getEmailTemplatesReq.isFetching);

  const handleClick = (id: number): void => {
    setSelectedId(id);
    setOpenEmailTemplateModal(true);
  };

  const handleClose = () => {
    setSelectedId(0);
    setOpenEmailTemplateModal(false);
  };
  const rows = useMemo(() => {
    return !getEmailTemplatesReq.isFetching ? emailTempaltesView : [];
  }, [getEmailTemplatesReq.isFetching, emailTempaltesView]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'sendTo',
      headerName: 'SEND TO',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {' '}
            <img src={EmailIcon} alt='' />
            {value}
          </div>
        );
      },
    },
    { field: 'bccTo', headerName: 'BCC-TO', flex: 1 },
    { field: 'sentEvent', headerName: 'SENT-WHEN (EVENT)', flex: 3 },
    {
      field: 'options',
      headerName: 'ACTIONS',
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
      //flex: 0.5,
      width: 100,
      renderCell: (params: GridCellParams) => (
        <IconButton onClick={() => handleClick(+params.row.id)} size='small'>
          <EditIcon style={{ color: orange[500] }} />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <h2 className={classes.textBox}>
        Here is a list of customizable email alert templates. These email alerts are sent to your End Users based on
        certain events.
      </h2>
      <Paper className={classes.dataGrid} elevation={0}>
        <Grid container justify='space-between' alignItems='center' className={classes.box}>
          <Search handelSearch={setFilter} />
        </Grid>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          sortingOrder={['desc', 'asc']}
          sortModel={[
            {
              field: 'sendTo',
              sort: 'desc' as GridSortDirection,
            },
          ]}
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
      <EmailTemplateForm
        open={openEmailTemplateModal}
        refetch={() => getEmailTemplatesReq.refetch()}
        handleClose={handleClose}
      />
    </>
  );
});
